/* eslint-disable import/prefer-default-export */
import axios from '../../axios';

// ---------------------------------------------------------------------------
// RH / Recrutamento & Seleção — Origens de candidatura (service layer, 0061).
//
// Catálogo editável ("de onde o candidato veio"). Já semeado com SITE,
// INDICAÇÃO, WHATSAPP, INSTAGRAM, GUPY, OUTROS. Sem paginação (lista curta).
// Leitura: hr:candidate:read; escrita: hr:recruitment_catalog:manage. Origins
// se inativam (is_active) em vez de excluir. Origin = { id, name, is_active }.
// ---------------------------------------------------------------------------

export async function listOrigins(filters = {}) {
   const { active } = filters;

   const params = {};
   // `active=1` → só as ativas (dropdown de cadastro). Omitir → todas (catálogo).
   if (active) params.active = 1;

   const response = await axios.get('/hr/recruitment/origins', { params });
   return response?.data?.data?.origins ?? [];
}

export async function createOrigin(payload) {
   const response = await axios.post('/hr/recruitment/origins', payload);
   return {
      origin: response?.data?.data?.origin ?? null,
      message: response?.data?.message ?? 'Origem criada com sucesso.',
   };
}

export async function updateOrigin(originId, payload) {
   const response = await axios.put(
      `/hr/recruitment/origins/${originId}`,
      payload,
   );
   return {
      origin: response?.data?.data?.origin ?? null,
      message: response?.data?.message ?? 'Origem atualizada com sucesso.',
   };
}
